(function () {
    'use strict';

    // Mime type groups - can be extended by adding new type with an array of mime types
    angular.module('elogbooksDirectives').constant('mimeTypeMap', {
        image: [
            'image/jpeg',
            'image/png',
            'image/gif',
            'image/tiff',
            'image/bmp',
            'image/webp',
            'image/heic',
            'image/heif'
        ],
        document: [
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/msword',
            'application/pdf',
            'application/vnd.oasis.opendocument.text',
            'application/vnd.oasis.opendocument.spreadsheet',
            'application/vnd.ms-powerpoint',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation'
        ],
        text: [
            'text/plain',
            'text/html',
            'text/csv'
        ],
        word: [
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        ],
        excel: [
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ],

        // File restrictions by file extension (used in setting: file_allowed_types)
        csv: ['text/csv'],
        pdf: ['application/pdf'],
        txt: ['text/plain'],
        msg: ['application/vnd.ms-outlook'],
        html: ['text/html'],
        xls: ['application/vnd.ms-excel'],
        doc: ['application/msword'],
        docx: ['application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
        odt: ['application/vnd.oasis.opendocument.text'],
        ods: ['application/vnd.oasis.opendocument.spreadsheet'],
        ppt: ['application/vnd.ms-powerpoint'],
        pptx: ['application/vnd.openxmlformats-officedocument.presentationml.presentation'],
        xlsx: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
        tiff: ['image/tiff'],
        bmp: ['image/bmp'],
        gif: ['image/gif'],
        jpeg: ['image/jpeg'],
        webp: ['image/webp'],
        png: ['image/png'],
        heic: ['image/heic'],
        heif: ['image/heif'],

        // Other file types - used in MimeTypesExtensionsMap Gedmo lib
        rtf: ['application/rtf', 'text/rtf'],
        zip: ['application/zip', 'application/x-zip-compressed'],
        rar: ['application/x-rar-compressed', 'application/x-rar'],
        '7z': ['application/x-7z-compressed'],
        tar: ['application/x-tar'],
        gz: ['application/gzip', 'application/x-gzip'],
        odp: ['application/vnd.oasis.opendocument.presentation'],
        odg: ['application/vnd.oasis.opendocument.graphics'],
        xml: ['application/xml', 'text/xml'],
        json: ['application/json'],
        js: ['application/javascript'],
        eml: ['message/rfc822'],
        ics: ['text/calendar'],
        vcf: ['text/x-vcard'],
        css: ['text/css'],

        // MS Office formats
        xlsb: ['application/vnd.ms-excel.sheet.binary.macroenabled.12'],
        xlsm: ['application/vnd.ms-excel.sheet.macroenabled.12'],
        xltm: ['application/vnd.ms-excel.template.macroenabled.12'],
        xltx: ['application/vnd.openxmlformats-officedocument.spreadsheetml.template'],
        docm: ['application/vnd.ms-word.document.macroenabled.12'],
        dotm: ['application/vnd.ms-word.template.macroenabled.12'],
        dotx: ['application/vnd.openxmlformats-officedocument.wordprocessingml.template'],
        pptm: ['application/vnd.ms-powerpoint.presentation.macroenabled.12'],
        wpl: ['application/vnd.ms-wpl'],
        pub: ['application/x-mspublisher'],
        mdb: ['application/x-msaccess'],
        xps: ['application/vnd.ms-xpsdocument'],
        oxps: ['application/oxps'],

        // Special formats
        exe: ['application/x-msdownload'],
        dll: ['application/x-msdownload'],
        com: ['application/x-msdownload'],
        bat: ['text/x-msdos-batch'],
        ps: ['application/postscript'],
        eps: ['image/x-eps'],
        ai: ['application/postscript'],
        apk: ['application/vnd.android.package-archive'],
        cer: ['application/pkix-cert'],
        p7s: ['application/pkcs7-signature'],
        application: ['application/x-ms-application'],
        url: ['application/x-mswinurl'],
        ini: ['application/x-wine-extension-ini'],
        lnk: ['application/x-ms-shortcut'],
        msi: ['application/x-msi'],
        crd: ['application/x-mscardfile'],
        mpp: ['application/vnd.ms-project'],
        vsd: ['application/vnd.visio'],
        kmz: ['application/vnd.google-earth.kmz'],
        wmz: ['application/x-ms-wmz'],
        sqlite: ['application/x-sqlite3'],

        // Image formats
        heic: ['image/heic'],
        avif: ['image/avif'],
        jxr: ['image/jxr'],
        pcx: ['image/x-pcx'],
        ras: ['image/x-cmu-raster'],
        psd: ['image/vnd.adobe.photoshop'],
        dwg: ['image/vnd.dwg'],
        dxf: ['image/vnd.dxf'],
        mdi: ['image/vnd.ms-modi'],
        svg: ['image/svg+xml'],
        ico: ['image/x-icon'],

        // Audio formats
        mp3: ['audio/mpeg'],
        wav: ['audio/x-wav'],
        aac: ['audio/aac', 'audio/x-aac'],
        flac: ['audio/flac'],
        ogg: ['audio/ogg'],
        m4a: ['audio/x-m4a'],

        // Video formats
        mp4: ['video/mp4'],
        avi: ['video/x-msvideo'],
        mov: ['video/quicktime'],
        wmv: ['video/x-ms-wmv'],
        flv: ['video/x-flv'],
        webm: ['video/webm'],
        mkv: ['video/x-matroska'],
        mpeg: ['video/mpeg'],
        m4v: ['video/x-m4v'],
        '3gp': ['video/3gpp'],
        asf: ['video/x-ms-asf'],

        // Programming and code files
        c: ['text/x-c'],
        cpp: ['text/x-c++'],
        sh: ['application/x-sh'],
        sql: ['application/sql', 'text/plain'],

        // Other special types
        empty: ['inode/x-empty', 'application/x-empty'],
        cdfv2: ['application/CDFV2', 'application/CDFV2-unknown'],
        enc: ['application/encrypted'],
        algol: ['text/x-Algol68']
    });
})();
